// MUST be the first import — installs global error handlers before React boots.
import "@/instrument";

// Iter179 — Aplica preferência de tamanho de texto ANTES do 1º paint
// (evita flash de reajuste durante LCP).
try {
  const saved = localStorage.getItem("jt.text-size");
  if (saved === "large") document.documentElement.style.fontSize = "115%";
  else if (saved === "xlarge") document.documentElement.style.fontSize = "130%";
} catch (_) { /* noop */ }

import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      onError={(error, componentStack) => {
        // Iter211/245 — Auto-recovery SILENCIOSO de chunk errors.
        // Nenhum banner, modal ou botão em qualquer cenário de
        // incompatibilidade de cache/bundle. O usuário nunca deve
        // ser interrompido por causa de deploy.
        if (
          typeof window !== "undefined"
          && typeof window.__jt_isChunkError === "function"
          && window.__jt_isChunkError(error)
        ) {
          if (typeof window.__jt_chunkReload === "function") {
            window.__jt_chunkReload();
            return; // Reload silencioso em progresso — não reporta.
          }
        }
        // Iter177 — reporta pro backend também (independente do Sentry).
        if (typeof window !== "undefined" && window.__jt_reportError) {
          window.__jt_reportError(error, { componentStack });
        }
      }}
      fallback={({ resetError, error }) => {
        // Iter245 — Fallback SILENCIOSO para chunk errors.
        // Se um ChunkLoadError chegou até aqui (o handler global do
        // instrument.js falhou em reciclar antes), NÃO mostramos modal.
        // Retornamos ``null`` (safe — nunca chamamos ``resetError()``
        // durante o render, então não geramos loop com WSOD). O
        // instrument.js já está disparando um reload silencioso em
        // paralelo; se falhar, o watchdog DOM (5.5s) faz o último
        // recurso. O usuário nunca vê nada.
        const isChunk =
          typeof window !== "undefined"
          && typeof window.__jt_isChunkError === "function"
          && window.__jt_isChunkError(error);
        if (isChunk) {
          // Dispara silenciosamente o reload proxy-proof (novo path).
          // Guard interno em ``__jt_wsod_recovering`` impede repetição.
          try {
            if (
              typeof window !== "undefined"
              && !window.__jt_wsod_recovering
              && typeof window.__jt_forceProxyProofReload === "function"
            ) {
              window.__jt_wsod_recovering = true;
              window.__jt_forceProxyProofReload("chunk-error-boundary");
            }
          } catch (_) { /* noop — watchdog cobre */ }
          return null;
        }
        // Erros que NÃO são de chunk (bugs reais de código) ainda
        // recebem o fallback tradicional — usuário pode tentar de novo
        // ou nos avisar. Este NÃO é sobre cache/versão, é sobre um
        // bug legítimo que precisamos investigar.
        return (
          <div
            role="alert"
            data-testid="sentry-fallback"
            style={{
              minHeight: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#0b1120",
              color: "#e2e8f0",
              fontFamily:
                "-apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
              padding: "32px",
            }}
          >
            <div style={{ maxWidth: 480, textAlign: "center" }}>
              <p
                style={{
                  color: "#f87171",
                  textTransform: "uppercase",
                  letterSpacing: "2px",
                  fontSize: 12,
                  fontWeight: 600,
                  marginBottom: 8,
                }}
              >
                JurisTube
              </p>
              <h1 style={{ fontSize: 24, marginBottom: 12 }}>
                Algo deu errado nesta página.
              </h1>
              <p style={{ color: "#94a3b8", lineHeight: 1.5, marginBottom: 24 }}>
                Já recebemos a notificação automática do erro. Você pode tentar
                recarregar — se persistir, escreva para{" "}
                <a
                  href="mailto:contato@juristube.com.br"
                  style={{ color: "#60a5fa" }}
                >
                  contato@juristube.com.br
                </a>
                .
              </p>
              <button
                onClick={resetError}
                style={{
                  background: "#dc2626",
                  color: "#fff",
                  fontWeight: 600,
                  padding: "12px 24px",
                  borderRadius: 999,
                  border: 0,
                  cursor: "pointer",
                }}
              >
                Tentar novamente
              </button>
            </div>
          </div>
        );
      }}
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
